<template>
  <main class="usage-terms-create">
    <usage-terms-form :admin="isAdminUsageTerms" />
  </main>
</template>

<script>
    import UsageTermsForm from '@views/usage-terms/components/UsageTermsForm.vue'

    export default {
        components: {
          UsageTermsForm
        },

        data() {
            return {

            }
        },

        computed: {
          isAdminUsageTerms() {
            return this.$route.path.includes('/admin')
          } 
        },

        methods: {

        },


        mounted() {
        },

        beforeDestroy() {
        },
    }
</script>

<style lang="scss" scoped>
</style>
